// extracted by mini-css-extract-plugin
module.exports = {"actions":"SocialAuthorizationDialog_actions__V_2D8"};